import React, { useEffect } from "react";
import { Button, Form, Row, Col } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Input, Card } from "antd";



const NotificationView = ({ dispatch, item }) => {
    const [form] = Form.useForm();


    const onBack = () => {
        const action = {
            type: "set_index_visibility",
            payload: 0
        };
        dispatch(action);
    };


    useEffect(() => {
        form.setFieldsValue({
            title: item.title,
            description: item.description,
            notification_date: item.notification_date
        });
    }, [form, item]);


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Row gutter={24}>
                    <Col span={24}>
                        <Card bodyStyle={{ padding: "15px" }} style={{ backgroundColor: "#d3d3d330" }}>
                            <Row gutter={24} align="middle">
                                <Col xl={4} lg={4} md={0} sm={0} xs={0}></Col>
                                <Col xl={16} lg={16} md={0} sm={0} xs={0} className="text-center">
                                    <h3 className="m-0 p-0">Të dhënat e njoftimit</h3>
                                </Col>
                                <Col xl={4} lg={4} md={0} sm={0} xs={0} className="text-right">
                                    <Button
                                        type="primary"
                                        ghost
                                        onClick={onBack}
                                        icon={<ArrowLeftOutlined />}
                                        size="large"
                                    >
                                        Kthehu
                                    </Button>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                </Row>
                <Row gutter={24} className="mt-2">
                    <Col span={24}>
                        <Card style={{ borderRadius: "0", minWidth: "100%", minHeight: "600px" }} bodyStyle={{ padding: "15px" }}>
                            <div className="mail-detail">
                                <Form
                                    layout="horizontal"
                                    form={form}
                                    labelCol={{ span: 4 }}
                                    wrapperCol={{ span: 20 }}
                                    labelAlign="left"
                                >
                                    <Row gutter={24} className="mt-2">
                                        <Col xl={5} lg={5} md={0} sm={0} xs={0}></Col>
                                        <Col xl={14} lg={14} md={0} sm={0} xs={0}>
                                            <Form.Item name="title" label="Titulli:">
                                                <Input type="text" className="w-100" disabled />
                                            </Form.Item>
                                            <Form.Item name="description" label="Përshkrimi:">
                                                <Input.TextArea type="text" rows={5} disabled />
                                            </Form.Item>
                                            <Form.Item name="notification_date" label="Data:">
                                                <Input type="text" disabled />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </Card>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};


export default NotificationView;